interface IApprovalPermission {
  perm_min_price?: number | null;
  perm_max_price?: number | null;
  approval_min_price?: number | null;
  approval_max_price?: number | null;
}

export default function getApprovalPermission({
  perm_min_price,
  perm_max_price,
  approval_min_price,
  approval_max_price,
}: IApprovalPermission): boolean {
  let minPricePerm = false;
  let maxPricePerm = false;

  if (!perm_min_price) {
    minPricePerm = true;
  } else if (!approval_min_price && perm_min_price === 0) {
    minPricePerm = true;
  } else if (
    (approval_min_price || approval_min_price === 0) &&
    (perm_min_price || perm_min_price === 0) &&
    perm_min_price <= approval_min_price
  ) {
    minPricePerm = true;
  }

  if (!perm_max_price) {
    maxPricePerm = true;
  } else if (!approval_max_price && perm_max_price === 0) {
    maxPricePerm = true;
  } else if (
    (approval_max_price || approval_max_price === 0) &&
    (perm_max_price || perm_max_price === 0) &&
    perm_max_price >= approval_max_price
  ) {
    maxPricePerm = true;
  }

  return minPricePerm && maxPricePerm;
}
